// extracted by mini-css-extract-plugin
var _1 = "main__CIw7U";
export { _1 as "main" }
export default { "main": _1 }
